var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "src": "/src/styles/logo.png",
      "alt": "logo"
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64f141c2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appComponents/components/Logo/Logo.vue
// module id = 681
// module chunks = 0